/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';

import GroupChannelHeader from '@sendbird/uikit-react/GroupChannel/components/GroupChannelHeader';
import GroupChannel from '@sendbird/uikit-react/GroupChannel';
import GroupChannelList from '@sendbird/uikit-react/GroupChannelList';
import { Box } from '@mui/system';

import {
  ClientChatTypes,
  createGroupChannel,
  getChannelProperties,
  getChannelUrl,
  getPharmacyChannelUrl,
  getProfessionalChannelUrl,
  getTypeOfUser,
  setChatActiveTab,
  TypeOfUser,
} from '@pharmaplan/common';
import { stub } from '@pharmaplan/common/helpers/utils';

import { useLocation } from 'react-router-dom';

import GroupChannelPreviewBase from '../common/Chat/GroupChannelPreviewBase';
import useProfessional from '../../hooks/Professional/useProfessional';
import GroupChannelTitle from '../Admin/ChatWindow/GroupChannelTitle';
import CreateGroupDialog from '../Admin/ChatWindow/CreateGroupDialog';
import GroupHeaderSearch from '../common/Chat/GroupHeaderSearch';
import CustomMessage from '../Admin/ChatWindow/CustomMessage';
import useChatSidebar from '../../hooks/Chat/useChatSidebar';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import useClientChat from '../../hooks/Chat/useClientChat';
import useChatSearch from '../../hooks/Chat/useChatSearch';
import { setDialog } from '../../reducers/dialogReducer';
import useSelfService from '../../hooks/useSelfService';
import ChatSidebar from '../common/Chat/ChatSidebar';
import strings from '../../localization';

import GroupListMiddleHeader from './GroupListMiddleHeader';
import ClientInputWrapper from './ClientInputWrapper';
import styles from './styles';
import './style.scss';

const { support, pharmacist, pharmacy, technician, student } = ClientChatTypes;

const ClientChat = () => {
  const { activeTab } = useChatSidebar();
  const { isSelfService } = useSelfService();
  const isNotSupport = activeTab !== support;

  const {
    onFirstMessage,
    extractedName,
    disableChat,
    handleChannelSelect,
    setChannelUrl,
    channelUrl,
  } = useClientChat();

  const location = useLocation();
  const { state } = location ?? {};
  const {
    personnelId: idPersonnel,
    url: clickedUrl,
    channelName: nameFromUrl,
    userType: typeFromUrl,
  } = state ?? {};

  const { formik } = useChatSearch();
  const { selfUserType } = useProfessional();

  const userType = useAppSelector(getTypeOfUser);
  const supportUrl = useAppSelector(getChannelUrl);
  const pharmacyUrl = useAppSelector(getPharmacyChannelUrl);
  const professionalUrl = useAppSelector(getProfessionalChannelUrl);
  const dispatch = useAppDispatch();
  const channelProps = useAppSelector(getChannelProperties);

  const {
    channelName,
    personnelId,
    userType: selectedType,
  } = channelProps ?? {};

  const userBasedUrl = (() => {
    if (userType === TypeOfUser.pharmacy) return pharmacyUrl;
    return professionalUrl;
  })();

  const url = (() => {
    if (isNotSupport) return userBasedUrl;
    return supportUrl;
  })();

  const title = {
    [support]: isSelfService
      ? strings.pharmagapSupport
      : strings.pharmaplanSupport,
    [pharmacist]: extractedName,
    [technician]: extractedName,
    [student]: extractedName,
    [pharmacy]: extractedName,
  };

  const showDialog = () => {
    dispatch(
      setDialog({
        showCloseButton: true,
        heading: {
          title: strings.upcomingBookingRequests,
        },
        maxWidth: 'sm',
        Component: <CreateGroupDialog />,
      }),
    );
  };

  useEffect(() => {
    setChannelUrl((prev) =>
      ({
        ...prev,
        url,
        channelName,
        personnelId,
        userType: selectedType,
      }));
  }, [url]);

  useEffect(() => {
    setChannelUrl((prev) =>
      ({
        ...prev,
        url: clickedUrl,
        personnelId: idPersonnel,
        channelName: nameFromUrl,
        userType: typeFromUrl,
      }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedUrl]);

  useEffect(() => {
    if (!state) {
      dispatch(setChatActiveTab(ClientChatTypes.support));
      dispatch(createGroupChannel(selfUserType?.toLowerCase()));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  const containerClassName = formik.values.showSearch ? 'add-margin' : '';

  return (
    <Box sx={styles.container}>
      <ChatSidebar />
      <Box
        component="div"
        className={containerClassName}
        sx={styles.subContainer}
      >
        {isNotSupport && (
          <GroupChannelList
            channelListQueryParams={{
              channelNameContainsFilter: formik.values.searchText,
            }}
            selectedChannelUrl={clickedUrl ?? channelUrl.url}
            disableAutoSelect
            renderHeader={() =>
              (
                <GroupHeaderSearch
                  customMiddle={GroupListMiddleHeader}
                  showDialog={showDialog}
                  formik={formik}
                />
              )}
            isMessageReceiptStatusEnabled
            renderChannelPreview={(props) =>
              (
                <GroupChannelPreviewBase {...props} />
              )}
            onChannelSelect={handleChannelSelect}
            onChannelCreated={stub}
          />
        )}
        {channelUrl && (
          <GroupChannel
            onBeforeSendUserMessage={onFirstMessage}
            renderMessageInput={() =>
              (
                <ClientInputWrapper isDisabled={disableChat} />
              )}
            channelUrl={channelUrl.url}
            renderChannelHeader={(props) =>
              (
                <GroupChannelHeader
                  {...props}
                  renderLeft={() =>
                    <div />}
                  renderRight={() =>
                    <div />}
                  renderMiddle={() =>
                    (
                      <GroupChannelTitle
                        title={title[activeTab as keyof typeof title]}
                        url={channelUrl.url}
                      />
                    )}
                />
              )}
            renderMessage={CustomMessage}
          />
        )}
      </Box>
    </Box>
  );
};
export default ClientChat;
